import {Component, Input, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-header-toolbar',
  templateUrl: './header-toolbar.component.html',
  styleUrls: ['./header-toolbar.component.scss'],
})
export class HeaderToolbarComponent implements OnInit {
  city: string = 'n1';
  @Input() title: string;
  @Input() backUrl: string;
  constructor(private route: Router, private modalController: ModalController) {}

  ngOnInit() {}

}
